// ** React Imports
import { useEffect, useState } from 'react';

// ** Styles Imports
import styles from './orderbookHeader.module.css';

// ** Formatted Messages
import { FormattedMessage, injectIntl } from 'react-intl';

// ** Icons Imports
import { BiChevronDown } from 'react-icons/bi';

import getPrecisionSelectOptions from '../../../../utility/orderbook/getPrecisionSelectOptions';
import { useDispatch, useSelector } from 'react-redux';
import { setGroupingSize } from '../../redux/slices/orderBookSlice';

function OrderbookHeader() {
  // ** Hooks
  const dispatch = useDispatch()

  // ** States
  const groupingSize = useSelector(state => state.orderBook.groupingSize)
  const selectedMarket = useSelector(state => state.selectedMarket.value)
  const theme = useSelector(state => state.theme.value)

  // State to store the selected value
  const [precisionOptions, setPrecisionOptions] = useState(getPrecisionSelectOptions(selectedMarket?.price_precision))
  const [selectedPrecision, setSelectedPrecision] = useState(
    getPrecisionSelectOptions(selectedMarket?.price_precision)[0]
  )
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)

  // Function to handle selection change
  const handlePrecisionChange = event => {
    const parsedNumber = parseFloat(event?.target.value)
    const value = Number.isInteger(parsedNumber) ? parseInt(parsedNumber) : parsedNumber
    if (value) {
      dispatch(setGroupingSize(value))
      setSelectedPrecision(value)
      setIsDropdownOpen(false)
    }
  }

  // Function to handle dropdown toggle
  const handleDropdownToggle = () => {
    setIsDropdownOpen(!isDropdownOpen)
  }

  // Function to handle option click
  const handleOptionClick = option => {
    const parsedNumber = parseFloat(option)
    const value = Number.isInteger(parsedNumber) ? parseInt(parsedNumber) : parsedNumber
    if (value) {
      dispatch(setGroupingSize(value))
      setSelectedPrecision(value)
      setIsDropdownOpen(false)
    }
  }

  useEffect(() => {
    const values = getPrecisionSelectOptions(selectedMarket?.price_precision)

    // On market change, get the new precision values
    setPrecisionOptions(values)

    if (values[0]) setSelectedPrecision(values[0])
  }, [selectedMarket])

  return (
    <div className={`${styles.container} ${theme === 'light' ? styles.light : ''}`}>
      <div className={styles.flexContainer}>
        <h2 className={styles.cardTitle}>
          <FormattedMessage id={'page.body.trade.orderbook'} />
        </h2>

        <div className={styles.groupByContainer}>
          <span className={styles.groupByLabel}>Group By</span>

          <div className={styles.dropdown}>
            <button className={styles.dropdownButton} onClick={handleDropdownToggle} title={selectedPrecision}>
              <span>{selectedPrecision}</span>
              <BiChevronDown size={16} className={`${styles.dropdownArrow} ${isDropdownOpen ? styles.open : ''}`} />
            </button>
            {isDropdownOpen && (
              <div className={styles.dropdownContainer}>
                {precisionOptions.map(precisionOption => (
                  <button
                    key={precisionOption}
                    className={`${styles.precisionButton} ${selectedPrecision === precisionOption ? styles.selectedOption : ''
                      }`}
                    onClick={() => handleOptionClick(precisionOption)}
                    title={precisionOption}
                  >
                    {precisionOption}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default injectIntl(OrderbookHeader)
